import { Component, Input, Output, EventEmitter, OnInit, forwardRef, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { BusinessDomainService, BusinessDomainConfig } from './business-domain.service';
import { MatSelectChange } from '@angular/material/select';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BlahService } from '@headpower/blah-ng';
import { IwmLocaleService } from 'src/app/services/iwm-locale.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-businessdomain-select',
    templateUrl: './business-domain-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BusinessDomainSelectComponent),
            multi: true
        }
    ]
})
export class BusinessDomainSelectComponent implements OnInit, ControlValueAccessor {

    @Input() id: string = 'task-business-domain';
    @Input() value: string;
    @Input() placeholder: string = '';
    @Input() class: string;
    @Input() multiple: boolean = false;
    @Input() disabled: boolean = false;
    @Input() includeClearFilterOption: boolean = false;
    @Input() targetType: string;
    @Input() taskType: string;

    @Output() valueChange: EventEmitter<string> = new EventEmitter();

    public businessDomains: BusinessDomainConfig[];

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private readonly businessDomainService: BusinessDomainService,
        private readonly cdRef: ChangeDetectorRef,
        private readonly blahService: BlahService,
        private readonly localeService: IwmLocaleService) {
    }

    ngOnInit() {
        if (this.targetType) {
            this.businessDomainService.getHiddenBusinessDomains(this.targetType, this.taskType).subscribe(res => {
                this.businessDomains = this.businessDomainService.getBusinessDomains()
                    .filter(t => {
                        return -1 === res.findIndex(i => i.HiddenObject.some(i => i.HiddenObject === t.value)) || this.value === t.value
                    });
                this.valueChange.emit(this.value);
                this.translateValuesAndSort();
            });
        } else {
            this.businessDomains = this.businessDomainService.getBusinessDomains()
        }
        this.cdRef.markForCheck();

        this.localeService.iwmLocale$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.translateValuesAndSort());
    }



    public change(change: MatSelectChange) {
        this.valueChange.emit(change.value);
        this.propagateChange(this.value);
    }

    writeValue(value: any): void {
        this.value = value ?? null;
    }

    propagateChange = (_: any) => { };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    translateValuesAndSort() {
        if (this.businessDomains) {
            this.businessDomains.forEach(o => {
                o.translatedValue = this.blahService.blah('task.businessDomain.' + o.value);
            });
            this.businessDomains.sort((a, b) => {
                if (a.value === 'None' && b.value !== 'None') {
                    return -1;
                }
                if (a.value !== 'None' && b.value === 'None') {
                    return 1;
                }
                return a.translatedValue.localeCompare(b.translatedValue);
            });
            this.cdRef.markForCheck();
        }
    }
}
